import {LeftOutlined} from "@ant-design/icons";
import {Button} from "antd";
import React from "react";


export const BackButton = ({onBack}) => {

    return <Button type="text" shape="circle" icon={<LeftOutlined/>} size={"small"} title={"Back"} onClick={onBack}/>

}